import { FC, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CompletedS3Source } from '@robocorp/robocloud-internal-cds-sdk/lib/src/types/RcInstanceDB';
import { useActions, useSelector } from '~/hooks';
import { ApiHelperSelectInput, ApiHelperSelectInputWrapperProps } from './ApiHelperSelectInput';

export const SelectRobotTask: FC<ApiHelperSelectInputWrapperProps> = ({
  value,
  setValue,
  pathParameters,
  ...props
}) => {
  const { t } = useTranslation();

  const loadingRobots = useSelector(({ entityStates }) => entityStates.activityTemplates.loading);
  const activityTemplateById = useSelector(
    ({ workspaceResources }) => workspaceResources.activityTemplates.byId,
  );

  const { getActivityTemplates } = useActions(({ activityTemplateActions }) => ({
    getActivityTemplates: activityTemplateActions.getActivityTemplates,
  }));

  const robotTaskItems = useMemo(() => {
    const robot = Object.entries(activityTemplateById).find(
      ([id]) => id === pathParameters.robot_id,
    );
    if (robot) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const config = robot[1].config as CompletedS3Source;
      const { tasks } = config.package || {
        tasks: undefined,
      };
      return tasks ? Object.keys(tasks).map((item) => ({ label: item, value: item })) : [];
    }

    return [];
  }, [activityTemplateById, pathParameters.robot_id]);

  useEffect(() => {
    getActivityTemplates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ApiHelperSelectInput
      label={t('robot.chooseTask')}
      items={robotTaskItems}
      onChange={(value) => setValue('task', value)}
      loading={loadingRobots}
      value={value}
      noItemsFound={t('noTasks')}
      {...props}
    />
  );
};
